import { render, staticRenderFns } from "./CAlertDialog.vue?vue&type=template&id=456b3e09&scoped=true"
import script from "./CAlertDialog.vue?vue&type=script&lang=js"
export * from "./CAlertDialog.vue?vue&type=script&lang=js"
import style0 from "./CAlertDialog.vue?vue&type=style&index=0&id=456b3e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b3e09",
  null
  
)

export default component.exports